module.exports = __webpack_public_path__ + "static/media/YF52_8.24d199e0.jpg";